import type { ReactNode } from 'react';

export const symbol_local_post_office: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M113-80q-14.03 0-23.51-9.49Q80-98.97 80-113v-298q0-14.02 9.49-23.51Q98.97-444 113-444h133v-206q0-97 68.25-163.5T480-880h173q94.58 0 160.79 67.5T880-650v540q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q820-97.25 820-110v-85H626v82q0 15-12 24t-28 9H113Zm513-175h194v-395q0-70.13-48.5-120.06Q723-820 653-820H479.5q-71.57 0-122.53 49Q306-722 306-650v206h280q16 0 28 9t12 24v156Zm-273-7 213-122H140l213 122ZM140-140h426v-189L383-224q-6.71 3.64-14.16 5.82T353.2-216q-8.2 0-15.79-2.18-7.58-2.18-14.41-5.82L140-329v189Zm0-244v20-.5 42.5-7 189-189 7-42.5.5-20Zm290-191q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h266q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H430Z"
		/>
	</svg>
);
